/**
 * tdesign v1.0.6
 * (c) 2023 TDesign Group
 * @license MIT
 */

var PickerProps = {
  cancelBtn: {
    type: [String, Boolean],
    default: true
  },
  columns: {
    type: [Array, Function],
    default: function _default() {
      return [];
    },
    required: true
  },
  confirmBtn: {
    type: [String, Boolean],
    default: true
  },
  header: {
    type: Function
  },
  renderLabel: {
    type: Function
  },
  title: {
    type: String,
    default: ""
  },
  value: {
    type: Array,
    default: void 0
  },
  modelValue: {
    type: Array,
    default: void 0
  },
  defaultValue: {
    type: Array
  },
  visible: Boolean,
  onCancel: Function,
  onChange: Function,
  onConfirm: Function,
  onPick: Function
};

export { PickerProps as default };
//# sourceMappingURL=props.js.map
